import withData from './hocs/withData';
import BuilderComponent from './BuilderComponent';

const Landing = withData(BuilderComponent);

export default Landing;
